module.exports = __webpack_public_path__ + "static/img/social-not-connected.06125e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/social-not-connected.svg
// module id = mDxL
// module chunks = 31